import React from "react";
import Banner from "../components/Banner";
import Category from "../components/Category";
import WhoWeAre from "../components/WhoWeAre";
import TrustedSource from "../components/TrustedSource";
import TrustedByCarousel from "../components/TrustedByCarousel";
import ppeBanner1 from "../assets/ppe_smallbanner1.webp";
import ppeBanner2 from "../assets/ppe_smallbanner2.webp";
import ppeBanner3 from "../assets/ppe_smallbanner3.webp";

const Home: React.FC = () => {
  const categoryItems = [
    {
      image: ppeBanner1,
      title: "Nitrile Gloves",
      alt: "Nitrile Gloves",
      link: "/nitrile-gloves.html",
    },
    {
      image: ppeBanner2,
      title: "Disposable Masks",
      alt: "Disposable Masks",
      link: "/disposable-masks.html",
    },
    {
      image: ppeBanner3,
      title: "Surface Wipes",
      alt: "Surface Wipes",
      link: "/surface-wipes.html",
    },
  ];
  return (
    <>
      <Banner />
      <Category items={categoryItems} />
      <WhoWeAre />
      <TrustedSource />
      <TrustedByCarousel />
    </>
  );
};

export default Home;
